import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Navbar } from "@/components/Navbar";
import { api, apiError } from "@/lib/api";
import { FamilyTree } from "@/components/story/FamilyTree";
import { StoryDraft } from "@/components/story/StoryDraft";
import { VoicesAndNarration } from "@/components/story/Voices";

const STEPS = [["tree", "1. Family tree"], ["draft", "2. Story review"], ["voices", "3. Voices & narration"]];

export default function StoryBuilder() {
  const [step, setStep] = useState("tree");
  const [tree, setTree] = useState(null);
  const [data, setData] = useState(null);
  const [voices, setVoices] = useState(null);
  const [status, setStatus] = useState({});

  const load = useCallback(async () => {
    try {
      const [t, d, v, s] = await Promise.all([api.get("/story2/tree"), api.get("/story2/draft"), api.get("/story2/voices"), api.get("/story2/status")]);
      setTree(t.data); setData(d.data); setVoices(v.data); setStatus(s.data);
    } catch (e) { toast.error(apiError(e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const busy = status.job?.status === "processing" || status.narration_job?.status === "processing";
  useEffect(() => { if (!busy) return; const t = setInterval(load, 4000); return () => clearInterval(t); }, [busy, load]);

  const generate = async () => { try { await api.post("/story2/draft"); load(); } catch (e) { toast.error(apiError(e)); } };

  if (!tree) return <div className="min-h-screen legacy-bg"><Navbar /><p className="text-center text-[#B9B3C8] pt-24" role="status">Opening your story…</p></div>;
  return (
    <div className="min-h-screen legacy-bg">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/dashboard" className="text-[#C9C2D8] underline underline-offset-4">← Back to your family</Link>
        <p className="eyebrow mt-4">Preview · narrated story upgrade (not yet on sale)</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#EDE6F7] mt-2 mb-2">Your narrated family story</h1>
        <p className="text-lg text-[#B9B3C8] mb-8">A separate story version made from your recordings. Your original keepsake and recordings stay exactly as they are.</p>
        <nav className="flex flex-wrap gap-2 mb-8" aria-label="Story steps">
          {STEPS.map(([id, t]) => (
            <button key={id} onClick={() => setStep(id)} aria-current={step === id} data-testid={`story-step-${id}`}
              className={`h-11 px-5 rounded-full border ${step === id ? "border-[#8B2CFF] text-[#EDE6F7] bg-[#1E1428]" : "border-[#33264A] text-[#A49CB8]"}`}>{t}</button>
          ))}
        </nav>
        {step === "tree" && <FamilyTree tree={tree} reload={load} />}
        {step === "draft" && <StoryDraft data={data} setData={(d) => { setData(d); load(); }} treeConfirmed={!!tree.confirmed_at} job={status.job} onGenerate={generate} />}
        {step === "voices" && <VoicesAndNarration voices={voices} draft={data?.draft} narrationJob={status.narration_job} reload={load} />}
      </main>
    </div>
  );
}
